<template>
  <div class=" copyright">
    <div class="policy-t">
      <div class="link-txt">
        <a href="https://privacy.ujoygames.com/" target="_blank">
          <img
            :src="
              require('../../assets/img/copyright/private/private-' +
                lang +
                '.png')
            "
            alt=""
            srcset=""
            class="p-txt"
          />
        </a>
        <img
          src="../../assets/img/copyright/line.png"
          alt=""
          srcset=""
          class="line"
        />
        <a href="https://useragreement.ujoygames.com/" target="_blank">
          <img
            :src="
              require('../../assets/img/copyright/policy/policy-' +
                lang +
                '.png')
            "
            alt=""
            srcset=""
            class="p-txt"
          />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["language"],

  data() {
    return {
      lang: localStorage.getItem("sof_locale") || "en"
    };
  },
  methods: {},
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
.copyright {
  height: 65px;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .policy-t {
    width: 440px;
    height: 29px;
    background-image: url("../../assets/img/copyright/bg.png");
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    .link-txt {
      position: absolute;
      bottom: 0;
      left: 167px;
      display: flex;
      align-items: center;
      gap: 1vw;
      a {
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .line {
      width: 1px;
      height: auto;
    }
    .p-txt {
      height: 15px;
      width: auto;
      img {
        display: block;
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/copyright.vue